import { gsap } from "gsap"
import { ScrollToPlugin } from "gsap/ScrollToPlugin"
import { ScrollTrigger } from "gsap/ScrollTrigger"

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin)

export default {
  block: $(".docs-container-sidebar"),
  buttons: null,
  lists: null,
  
  disableElements() {
    $('.sidebar-list').removeClass("is-active");
    this.lists.removeClass("is-active");
  },
  init() {
    if (!this.block.length) return;
    this.buttons = this.block.find(".sidebar-list > .sidebar-list-header");
    this.lists = this.block.find(".sidebar-list-box");

    this.buttons.on("click", (e) => {
      e.preventDefault();
      const btn = $(e.delegateTarget);
      const list = btn.parent().find("ul");
      btn.parent().toggleClass("is-active");
      list.toggleClass("is-active");
    });
    $('.sidebar-mobile-trigger').on('click', (e) => {
      e.preventDefault()
      $(e.delegateTarget).toggleClass('active');
      $('.sidebar-mobile').toggleClass('active');
    })
    if($('.product-content-list').length){
      ScrollTrigger.create({
        trigger: ".product-content-list",
        start: "top top+=60",
        endTrigger: ".product-content-inner",
        end: "bottom center",
        pin: true,
        pinSpacing: false,
        scrub: 1,
      })
    }
  },
};
